import { BoxBase, CardBase, StackBase } from '@fmc-digital/ui';
import { useTheme } from '@mui/material';
import { default as SkeletonBase } from '@mui/material/Skeleton';
import React from 'react';

export const PaymentCardSkeleton = () => {
    const theme = useTheme();
    return (
        <CardBase sx={{ padding: 0 }}>
            <StackBase
                direction={{ xs: 'column', xl: 'row' }}
                justifyContent="space-between"
                sx={{
                    borderBottom: {
                        xs: undefined,
                        xl: `1px solid ${theme.palette.surface.light}`
                    },
                    padding: theme.spacing(4)
                }}
            >
                <StackBase gap={2} mb={2} width={{ lg: '45%' }}>
                    <SkeletonBase width="100%" height={32} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="60%" height={64} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="100%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="30%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                </StackBase>
                <StackBase gap={2} width={{ lg: '45%' }}>
                    <SkeletonBase width="60%" height={64} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="70%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="70%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="70%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                </StackBase>
            </StackBase>
            <StackBase gap={{ xs: 0, xl: 4 }} direction={{ xs: 'column', xl: 'row' }}>
                <StackBase padding={4} gap={2} width={{ lg: '50%' }}>
                    <SkeletonBase width="100%" height={32} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="60%" height={64} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="100%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="30%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                </StackBase>
                <BoxBase
                    sx={{
                        borderRight: {
                            xs: undefined,
                            xl: `1px solid ${theme.palette.surfaceDark.light}`
                        }
                    }}
                />
                <StackBase padding={4} gap={2} width={{ lg: '100%' }}>
                    <SkeletonBase width="100%" height={32} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="100%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="30%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width="30%" height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                </StackBase>
            </StackBase>
        </CardBase>
    );
};
